//import React from 'react';
import { DatePicker } from 'antd';
// import css from './css.module.less';
// import moment from 'moment';
// import { Button } from 'src/components/Antd';

const { RangePicker } = DatePicker;

export { RangePicker };
